export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateRequired = (value) => {
  if (value == null) return 'This field is required.';
  if (typeof value === 'string' && value.trim() === '') return 'This field is required.';
  return null;
};

export const validateEmail = (value) => {
  if (!value) return 'Please enter your email address.';
  return EMAIL_REGEX.test(value) ? null : 'Please enter a valid email address.';
};

export const validatePhone = (value) => {
  if (!value) return null;
  const digits = String(value).replace(/\D/g, '');
  return digits.length === 10 ? null : 'Please enter a valid 10-digit phone number.';
};

export const validateMaxLength = (max) => (value) => {
  if (!value) return null;
  return String(value).length <= max ? null : `Please keep this under ${max} characters.`;
};
